<h2 mat-dialog-title translate>Unsubmitted Application</h2>
<mat-dialog-content>
    <div style="padding-bottom: 10px;">{{textBlock1}}</div>
    <div translate style="padding-bottom: 10px;">Do you want to continue with that application or start a new one?</div>
    <div style="display: flex; justify-content: space-around;">
        <a class="link" (click)="continueClick()" translate>Continue with Unfinished</a>
        <a class="link" (click)="newClick()" translate>Start New</a>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>